import { optionsForSubscription } from "./options";

export const transformProducts = (products, isServices = false,isRawMaterials = false) => {
  console.log("LINE NO 05 IN SALE UTILITY transformProducts", products);
  if (isServices) {
    return products.map((product) => ({
      productName: product.serviceName,
      quantity: 1,
      subscriptionType: "",
      salePrice: product.salePrice,
      discount: product.discount || 0,
      finalPrice: product.serviceCost,
      serviceId: product.serviceId,
      subscriptionEligible: product.subscriptionEligible,
      purchasePrice: product.serviceCost,
      subscription: product.subscription,
      productSubCategory: product.productSubCategory,
      productCategory: product.productCategory,
      unitSize: product.unitSize,
      brandName: product.brandName,
      batchNumber: product.batchNumber,
      expDate: product.expDate,
      mfgDate: product.mfgDate,
      subscriptionOption: optionsForSubscription(product.subscription),
      igst: product?.igst,
      hsnNumber: product.hsnNumber || "",
      cgst: product?.cgst,
      sgst: product?.sgst_utgst || 0,
      cess: product?.cess,
      showReturn: product?.showReturn,
      returnPeriod: product?.returnPeriod,
      lowStock: product.lowStock,
      sku_number: product.sku_number,
    }));
  }
  return products.map((product) => ({
    productName: product.productName,
    quantity: 1,
    subscriptionType: "",
    salePrice: product.salePrice,
    discount: product.discount || 0,
    hsnNumber: product.hsnNumber || "",
    gstPercent: product.gstPercentage,
    finalPrice: product.purchasePrice,
    productId: product.productId,
    discountUnit: product.discountUnit,
    subscriptionEligible: product.subscriptionEligible,
    purchasePrice: product.purchasePrice,
    subscription: product.subscription,
    productSubCategory: product.productSubCategory,
    productCategory: product.productCategory,
    unitSize: product.unitSize,
    brandName: product.brandName,
    batchNumber: product.batchNumber,
    expDate: product.expDate,
    mfgDate: product.mfgDate,
    subscriptionOption: optionsForSubscription(product.subscription),
    igst: product?.igst,
    cgst: product?.cgst,
    sgst: product?.sgst_utgst,
    cess: product?.cess,
    showReturn: product?.showReturn,
    returnPeriod: product?.returnPeriod,
    mrp: product?.mrp,
    openingStock: product?.openingStock,
    lowStock: product?.lowStock,
  }));
};

export const calculateDiscount = (product) => {
  const salePrice = parseFloat(product.salePrice);
  const discount = parseFloat(product.saleDiscount) || 0;
  const discountUnit = product.saleDiscountUnit;

  let discountAmount = 0;
  if (discountUnit === "₹") {
    discountAmount = discount;
  } else if (discountUnit === "%") {
    discountAmount = (discount / 100) * salePrice;
  } else {
    discountAmount = 0;
  }
  return discountAmount;
};

export const getHexTimeInSixDigit = () => {
  const now = new Date();
  const hours = now.getHours().toString(16).padStart(2, "0");
  const minutes = now.getMinutes().toString(16).padStart(2, "0");
  const seconds = now.getSeconds().toString(16).padStart(2, "0");

  return `${hours}${minutes}${seconds}`;
};
